module.exports = __webpack_public_path__ + "static/media/qps_benchmarking.171a1993.png";